import React from 'react';
import moment from 'moment';
import { partitionListBy } from '../../helpers';
import { MessagesByDate } from './MessagesByDate';

var getMessageDate = function getMessageDate(message) {
  return moment(message.createdAt).format('YYYY-MM-DD');
};

var differentDate = function differentDate(m1, m2) {
  return getMessageDate(m1) !== getMessageDate(m2);
};

export var MessagesList = function MessagesList(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: "messages-list",
    "aria-label": "chat window",
    role: "region"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "sr-only"
  }, "Chat window"), partitionListBy(differentDate, props.messages).map(function (messages, i) {
    return /*#__PURE__*/React.createElement(MessagesByDate, {
      key: i,
      discussion: props.discussion,
      profile: props.profile,
      messages: messages,
      actions: props.actions
    });
  }));
};